import { IMediaItem } from 'types/media'
import {
  OnDrag,
  OnDragEnd,
  OnResize,
  OnResizeEnd,
  OnResizeStart
} from 'react-moveable'
import { dispatch } from 'store'
import { projectDataThunks } from 'store/features/projectData/thunks'
import { useWebWoodContext } from 'context/WebWoodContext'
import { useTextSpecificActions } from './use-text-specific-actions'

export const useMovableActions = (item: IMediaItem) => {
  const engineId = `${item.id}-${item.assetId}`
  const { updateObjectById, getObjectById } = useWebWoodContext()
  const {
    handleTextResizeStart,
    handleTextResize,
    handleTextResizeEnd,
    isText
  } = useTextSpecificActions(item)

  const handleDrag = ({ target, left: dragLeft, top: dragTop }: OnDrag) => {
    target.style.left = `${dragLeft}px`
    target.style.top = `${dragTop}px`
    updateObjectById(engineId, {
      x: dragLeft,
      y: dragTop
    })
  }

  const handleDragEnd = ({ lastEvent }: OnDragEnd) => {
    if (!lastEvent) return
    dispatch(
      projectDataThunks.updateMediaItem({
        id: item.id,
        updates: {
          coordinates: {
            x: lastEvent.left,
            y: lastEvent.top
          }
        }
      })
    )
  }

  const handleResizeStart = (e: OnResizeStart) => {
    if (isText) {
      handleTextResizeStart(e)
    }
  }

  const handleResize = ({ target, width, height, drag, datas }: OnResize) => {
    target.style.width = `${width}px`
    target.style.height = `${height}px`
    target.style.left = `${drag.left}px`
    target.style.top = `${drag.top}px`
    const engineUpdate: Record<string, unknown> = {
      x: drag.left,
      y: drag.top
    }

    if (isText) {
      handleTextResize(engineUpdate, datas, width)
    } else {
      engineUpdate.width = width
      engineUpdate.height = height
    }

    updateObjectById(engineId, engineUpdate)
  }

  const handleResizeEnd = ({
    target,
    lastEvent,
    datas,
    moveable
  }: OnResizeEnd) => {
    if (!lastEvent) return
    const { width: newWidth, height: newHeight, drag } = lastEvent
    const { left: newLeft, top: newTop } = drag

    const updates: Partial<IMediaItem> = {
      coordinates: {
        x: newLeft,
        y: newTop
      }
    }

    if (isText) {
      handleTextResizeEnd(updates, datas, newWidth)
      const engineObject = getObjectById(engineId)
      updates.width = engineObject?.width ?? newWidth
      updates.height = engineObject?.height ?? newHeight
      target.style.width = `${updates.width}px`
      target.style.height = `${updates.height}px`
      moveable.updateRect()
    } else {
      updates.width = newWidth
      updates.height = newHeight
    }

    dispatch(
      projectDataThunks.updateMediaItem({
        id: item.id,
        updates
      })
    )
  }

  return {
    handleDrag,
    handleDragEnd,
    handleResizeStart,
    handleResize,
    handleResizeEnd
  }
}
